import React, { useCallback, useEffect, useState } from 'react';
import { Card, CardTitle, Label, Row, Col, Button } from 'reactstrap';
import { UpdateTagsInfo } from '../../../../graphql/Mutation';
import { selectThemeColors } from '@utils';
import { useMutation } from '@apollo/client';
import CreatableAsyncCustom from '@components/input/CreatableAsyncCustom';

const _emotions = new Map();
const _countries = new Map();
const _content = new Map();
const _gender = new Map();

export const TagSettingsModule = ({ data }) => {
  const [updateTagsInfo] = useMutation(UpdateTagsInfo);
  const [emotions, setEmotions] = useState([]);
  const [countries, setCountries] = useState([]);
  const [gender, setGender] = useState([]);
  const [content, setContent] = useState([]);

  const handleSubmit = useCallback(async () => {
    try {
      await updateTagsInfo({
        variables: {
          updateTagsInfo: {
            countries: [..._countries.keys()],
            content: [..._content.keys()],
            emotions: [..._emotions.keys()],
            gender: [..._gender.keys()]
          }
        }
      });
    } catch (e) {}
  }, [emotions, countries, gender, content]);

  const handleUpdate = (type, values) => {
    if (type === 'gender') {
      _gender.clear();
      values.forEach((item) => {
        _gender.set(item._id, item);
      });
      setGender([..._gender.values()]);
    }
    if (type === 'countries') {
      _countries.clear();
      values.forEach((item) => {
        _countries.set(item._id, item);
      });
      setCountries([..._countries.values()]);
    }
    if (type === 'content') {
      _content.clear();
      values.forEach((item) => {
        _content.set(item._id, item);
      });
      setContent([..._content.values()]);
    }
    if (type === 'emotions') {
      _emotions.clear();
      values.forEach((item) => {
        _emotions.set(item._id, item);
      });
      setEmotions([..._emotions.values()]);
    }
    handleSubmit();
  };

  const formatData = useCallback(() => {
    data.emotions.forEach((item) => {
      _emotions.set(item._id, item);
    });
    data.countries.forEach((item) => {
      _countries.set(item._id, item);
    });
    data.gender.forEach((item) => {
      _gender.set(item._id, item);
    });
    data.content.forEach((item) => {
      _content.set(item._id, item);
    });
    setGender([..._gender.values()]);
    setContent([..._content.values()]);
    setCountries([..._countries.values()]);
    setEmotions([..._emotions.values()]);
  }, []);

  useEffect(() => {
    formatData();
  }, [formatData]);

  return (
    <Card body>
      <CardTitle>Tags</CardTitle>
      <Row>
        <Col md="4" lg="4">
          <Label className="form-label" for="name">
            Emociones:
          </Label>
          <CreatableAsyncCustom
            theme={selectThemeColors}
            disabled={false}
            type="emotions"
            values={emotions}
            setOptions={handleUpdate}
          />
        </Col>
        <Col md="4" lg="4">
          <Label className="form-label" for="name">
            Paises:
          </Label>
          <CreatableAsyncCustom
            theme={selectThemeColors}
            disabled={false}
            type="countries"
            values={countries}
            setOptions={handleUpdate}
          />
        </Col>
        <Col md="4" lg="4">
          <Label className="form-label" for="name">
            Genero:
          </Label>
          <CreatableAsyncCustom
            theme={selectThemeColors}
            disabled={false}
            values={gender}
            type="gender"
            setOptions={handleUpdate}
          />
        </Col>
        <Col md="6" lg="6">
          <Label className="form-label" for="name">
            Contenido:
          </Label>
          <CreatableAsyncCustom
            theme={selectThemeColors}
            disabled={false}
            values={content}
            type="content"
            setOptions={handleUpdate}
          />
        </Col>
      </Row>
    </Card>
  );
};
